import { createSlice } from '@reduxjs/toolkit';
import { post } from 'api/fetch';
import { updatePlanholderInfo } from 'products/nomad_insurance/state/planholder';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/group-members',
  initialState: {
    isLoading: false,
    error: null,
    loadingGroupMemberID: null,
    isValid: false
  },
  reducers: {
    // addGroupMember
    addGroupMemberRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.loadingGroupMemberID = 0;
    },
    addGroupMemberSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
      state.loadingGroupMemberID = null;
    },
    addGroupMemberFailure: (state, { payload }) => {
      state.isLoading = true;
      state.error = payload;
      state.loadingGroupMemberID = null;
    },
    // deleteGroupMember
    deleteGroupMemberRequest: (state, { payload }) => {
      state.loadingGroupMemberID = payload;
      state.error = null;
    },
    deleteGroupMemberSuccess: (state) => {
      state.loadingGroupMemberID = null;
      state.error = null;
    },
    deleteGroupMemberFailure: (state, { payload }) => {
      state.loadingGroupMemberID = null;
      state.error = payload;
    },
    // editGroupMember
    editGroupMemberRequest: (state, { payload }) => {
      state.loadingGroupMemberID = payload;
      state.error = null;
    },
    editGroupMemberSuccess: (state) => {
      state.loadingGroupMemberID = null;
      state.error = null;
    },
    editGroupMemberFailure: (state, { payload }) => {
      state.loadingGroupMemberID = null;
      state.error = payload;
    },
    setValidity: (state, { payload }) => {
      state.isValid = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const addGroupMember = (info) => async (dispatch, useState) => {
  const { groupMembers } = useState().nomadInsurance.planholder.planholder;

  dispatch(actions.addGroupMemberRequest());

  const body = {
    add: [{ ...info }]
  };

  try {
    await dispatch(
      updatePlanholderInfo({
        groupMembers: [...groupMembers, { groupMemberID: 0, ...info }]
      })
    );

    const response = await post('/group-members/v1', body, {
      isNIOrchestrator: true
    });
    await dispatch(updatePlanholderInfo({ groupMembers: response.groupMembers }));
    dispatch(actions.addGroupMemberSuccess());
  } catch (error) {
    await dispatch(updatePlanholderInfo({ groupMembers }));
    dispatch(actions.addGroupMemberFailure(error));
  }
};

export const deleteGroupMember = (id) => async (dispatch, useState) => {
  if (useState().nomadInsurance.groupMembers.loadingGroupMemberID) return;

  dispatch(actions.deleteGroupMemberRequest(id));

  const body = {
    delete: [{ groupMemberID: id }]
  };

  try {
    const response = await post('/group-members/v1', body, {
      isNIOrchestrator: true
    });
    await dispatch(updatePlanholderInfo({ groupMembers: response.groupMembers }));
    dispatch(actions.deleteGroupMemberSuccess());
  } catch (error) {
    dispatch(actions.deleteGroupMemberFailure(error));
  }
};

export const editGroupMember = (info) => async (dispatch, useState) => {
  if (useState().nomadInsurance.groupMembers.loadingGroupMemberID) return;

  dispatch(actions.editGroupMemberRequest(info.groupMemberID));

  const body = {
    edit: [{ ...info }]
  };

  try {
    const response = await post('/group-members/v1', body, {
      isNIOrchestrator: true
    });

    await dispatch(updatePlanholderInfo({ groupMembers: response.groupMembers }));
    dispatch(actions.editGroupMemberSuccess());
  } catch (error) {
    dispatch(actions.editGroupMemberFailure(error));
  }
};

export const setValidity = (isValid) => (dispatch) => {
  dispatch(actions.setValidity(isValid));
};
